export const OurTeamData = [
    {
        name:"Prof. Sanket Jain",
        Des:"Program Coordinator, SSAC",
        src:"./team/sanket.jpeg",
        instagram:"https://www.instagram.com/sanketjain29?igsh=MW9yc2d0NWc1N2wydQ=="
    },
    {
        name:"Arkansh Aryan",
        Des:"President, SSAC",
        src:"./team/arkansh.jpeg",
        instagram:"https://www.instagram.com/iamarkansh?igsh=MTlwcjE5cjN5dmI4cg=="
    },
    {
        name:"Nikhil Pandey",
        Des:"Vice-President, SSAC",
        src:"./team/nikhil.jpeg",
        instagram:"https://www.instagram.com/nikhill.pandeyy?igsh=NmlxY3Uyd2pkenJr"
    },
    {
        name:"Naina Rawat",
        Des:"Treasurer, SSAC",
        src:"./team/naina.jpg",
        instagram:"https://www.instagram.com/_.nainaaa___/"
    }
]